import React from "react";
// Placeholder images (replace with actual images as needed)
import placeholderImg from "./assets/hero.jpg";

const solutions = [
  {
    title: "Database Reactivation",
    desc: "Pull fresh sales from leads you've already paid for and haven't bought, using conversational AI",
    img: placeholderImg,
  },
  {
    title: "Speed To Lead",
    desc: "Stop losing sales to competitors who are faster to the phone, by getting AI to work your leads 24/7",
    img: placeholderImg,
  },
  {
    title: "Out Of Hours",
    desc: "Stop 'Out of Hours' leads going unanswered and wasting time each morning on unqualified prospects with AI",
    img: placeholderImg,
  },
  {
    title: "Google Reviews",
    desc: "Improve business credibility and customer opinion replying to reviews without spending man-hours using AI",
    img: placeholderImg,
  },
  {
    title: "Voice",
    desc: "Use AI to handle inbound calls to redirect leads, take information and book / rearrange appointments",
    img: placeholderImg,
  },
  {
    title: "Abandoned Cart",
    desc: "Secure sales that would have otherwise been lost to the void by following up with users who left before purchasing",
    img: placeholderImg,
  },
];

function Solutions() {
  return (
    <>
      <section className='solutions-section'>
        <h2 className='solutions-title'>Our Solutions</h2>
        <div className='solutions-cards'>
          {solutions.map((sol, i) => (
            <div className='solution-card' key={i}>
              <img src={sol.img} alt={sol.title} className='solution-img' />
              <h3 className='solution-card-title'>{sol.title}</h3>
              <p className='solution-card-desc'>{sol.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className='solutions-cta-section'>
        <div className='solutions-cta-inner'>
          <h3 className='solutions-cta-headline'>
            Pull 5 or 6 figures worth of sales from old leads you'd written off
            for dead
          </h3>
          <p className='solutions-cta-desc'>
            Our Database Reactivation bot helps businesses treat every lead like
            it's their last. The bot takes all the people in a database who
            haven't bought and strikes up a conversation with them via SMS.
            <br />
            <br />
            Then next thing you know, they're booking calls and you're up
            $10K-$100K+ in sales.
          </p>
          <a href='#contact' className='cta-btn solutions-cta-btn'>
            Get Started
          </a>
          <div className='solutions-cta-subheadline'>
            Let's get started
            <br />
            Ready to get the perks of a 25/7 sales team WITHOUT the expense?
          </div>
        </div>
      </section>
      <section className='agency-intro-section'>
        <div className='agency-intro-inner'>
          <h2 className='agency-intro-title'>AI Automation Agency</h2>
          <p className='agency-intro-desc'>
            We're in the business of getting our client's results. We simply
            leverage the power of AI to do that. Our mission is to pull in
            multiple $1000s in extra sales for our clients without asking them
            to do any extra work. We use our AI services to streamline sales
            processes, increase productivity and turn time-sucking tasks into
            profit centers.
          </p>
          <a href='#contact' className='cta-btn agency-intro-btn'>
            Get Started Now
          </a>
          <div className='agency-intro-sub'>
            <strong>Make more sales & get better qualified leads</strong>
            <br />
            Find out if you can remove expensive bottlenecks and add a few extra
            zeros to your business account with AI. Book in a call here, so we
            can chat.
          </div>
          <a
            href='#contact'
            className='cta-btn agency-intro-btn schedule-call-btn'
          >
            Schedule a Call
          </a>
        </div>
      </section>
    </>
  );
}

export default Solutions;
